import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Helmet } from 'react-helmet-async';
import { useMenu } from '../../hooks/useMenu';
import MetalStreamAmountForm from '../../components/Forms/MetalStreamAmountForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { Heading } from '../../components/Heading';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const MetalStreamInvest = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('metalstream.titleTagMonthlyInvest', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={32}>{t('metalstream.investTitle')}</Heading>
      <MetalStreamAmountForm nextPath={activeItem?.nextPath} />
    </OnBoardingContainer>
  );
};

export default MetalStreamInvest;
